"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ExpandableItemHeader_1 = __importDefault(require("@Components/Navigations/Sidebar/ExpandableItemHeader"));
const clsx_1 = __importDefault(require("clsx"));
require("./index.scss");
const ExpandableItem = (props) => {
    const { className } = props, headerProps = __rest(props, ["className"]);
    const isExpandable = props.children !== undefined;
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(() => {
        const storedValue = localStorage.getItem(props.heading);
        return storedValue ? JSON.parse(storedValue) : true;
    });
    (0, react_1.useEffect)(() => {
        if (isExpanded !== null && typeof isExpanded !== 'undefined') {
            localStorage.setItem(props.heading, JSON.stringify(isExpanded));
        }
    }, [isExpanded]);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('expandable-item', className) }, isExpandable ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ExpandableItemHeader_1.default, Object.assign({}, headerProps, { onClick: () => {
                setIsExpanded(!isExpanded);
            }, isExpanded: isExpanded })),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('expandable-item-sub', isExpanded && 'expanded') }, props.children))) : (react_1.default.createElement(ExpandableItemHeader_1.default, Object.assign({}, headerProps)))));
};
exports.default = ExpandableItem;
